// Extract the location without the app URL basename

import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useCurrentRoute } from "../Routing/useCurrentRoute";
import { resolve } from "../Routes/RoutesContext";
import { persistor } from "../../config/reduxStore";

import { setStoredLocation } from "../../reducers/location";

//
export function intlLocationFor(location /*, intl*/) {
  return location;

  // const { pathname } = location;
  // const basename = intlLocationBasenameFor(intl);

  // if (!basename) return { pathname };

  // const rx = new RegExp(`^${basename}/`);
  // return { pathname: pathname.replace(rx, "/") };
}

// Basename used for routing when locale is not fr
//
export function intlLocationBasenameFor(intl) {
  const { locale, defaultLocale } = intl;

  return !locale || locale === defaultLocale ? "" : `/${locale}`;
}

// This method starts from the currentLocation pathname (ex: "/a/b/c") and looks for
// the first "parent location" that matches an existing route and returns it, i.e. :
//   1. It checks if "/a/b" matches a route
//   2. It checks if "/a" matches a route
//   3. If none matched, it returns "/"
//
export function findClosestMatchingParentLocation(pathname) {
  const checkParentPathExistence = path => {
    const parentPath = path.replace(/\/[^/]+\/?$/, "");
    if (parentPath === "") return "/";

    const route = resolve(parentPath);
    return route ? parentPath : checkParentPathExistence(parentPath);
  };

  return checkParentPathExistence(pathname);
}

// Stores a location through the existing stored location flow and flushes redux-persist
// before a hard reload, so modal routes can still return to it after sign-in.
export function useStoreLocationForReload() {
  const dispatch = useDispatch();

  return useCallback(
    async location => {
      if (!location) return;

      dispatch(setStoredLocation(location));

      // The browser may reload immediately after this call, so force redux-persist to
      // write the stored location before the current app instance is torn down.
      await persistor.flush();
    },
    [dispatch]
  );
}

export function useNonModalLocation() {
  const lastNonModalLocation = useSelector(
    ({ location }) => location.lastNonModalLocation
  );
  const { isModal, location: currentLocation } = useCurrentRoute();
  const { pathname } = currentLocation;

  if (isModal && lastNonModalLocation) {
    return lastNonModalLocation;
  } else if (!isModal) {
    return currentLocation;
  } else {
    return { pathname: findClosestMatchingParentLocation(pathname) };
  }
}
